import { FC } from 'react';
import Button from 'v3/common/components/Button';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import UserInput from 'v3/common/components/UserInput';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';

const Fyers: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles, switchPage }) => {
  const { updatePartialConfigs, validateClientIdAndRedirect, reDirectPage, isMobile, changeApiKey } =
    brokerSpecificHandles;
  const {
    clientId,
    isClientValidated,
    shouldShowApiKey,
    apiKey,
    secretKey,
    isLoading,
    isValidForm,
    selectedBrokerConfig,
    shouldShowSecretKey,
  } = userConfigs;

  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isClientValidated ? reDirectPage({}, false) : validateClientIdAndRedirect();
      }}
    >
      <UserInput
        labelValue="Client Id"
        id={`${selectedBrokerConfig?.id}-client-id`}
        value={clientId}
        isDisabled={isClientValidated}
        placeholder="Enter Client Id"
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
        autoFocus={!isMobile}
      />

      {clientId && !isClientValidated && (
        <button type="button" onClick={() => changeApiKey()}>
          <i className="fa-regular fa-gear fa-spin" />
          Change api?
        </button>
      )}

      {shouldShowApiKey && (
        <UserInput
          labelValue="API Key"
          id={`${broker}-api-key`}
          value={apiKey}
          placeholder="Enter API Key"
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}

      {shouldShowSecretKey && (
        <UserInput
          labelValue="API Secret"
          id={`${broker}-secret-key`}
          value={secretKey}
          type="password"
          placeholder="Enter API Secret"
          onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
        />
      )}

      {isClientValidated && (
        <button type="button" onClick={() => switchPage()}>
          <img src="/gear.svg" alt="" />
          <span className="ms-2">How to generate API?</span>
        </button>
      )}

      {!isValidForm && <div className="alert alert-danger">Please provide the details</div>}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};
export default Fyers;
